import { useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

const LenderLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const currentUser = authService.getCurrentUser();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  return (
    <div className="page">
      <aside className={`navbar navbar-vertical navbar-expand-lg ${sidebarOpen ? 'show' : ''}`}>
        <div className="container-fluid">
          <button 
            className="navbar-toggler" 
            type="button"
            onClick={() => setSidebarOpen(false)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          
          <h1 className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
            <Link to="/lender/brokers">
              <img src="/assets/UFF_Logo_Main_2026.png" alt="United Fidelity Funding Corp" style={{ height: '40px', width: 'auto' }} />
            </Link>
          </h1>
          
          <div className="navbar-nav">
            <div className="nav-item">
              <Link to="/lender/dashboard" className="nav-link">
                <span className="nav-link-icon d-md-none d-lg-inline-block">
                  <i className="ti ti-dashboard"></i>
                </span>
                <span className="nav-link-title">Dashboard</span>
              </Link>
            </div>
            <div className="nav-item">
              <Link to="/lender/brokers" className="nav-link">
                <span className="nav-link-icon d-md-none d-lg-inline-block">
                  <i className="ti ti-building"></i>
                </span>
                <span className="nav-link-title">Broker Companies</span>
              </Link>
            </div>
            <div className="nav-item">
              <Link to="/lender/feature-management" className="nav-link">
                <span className="nav-link-icon d-md-none d-lg-inline-block">
                  <i className="ti ti-toggle-left"></i>
                </span>
                <span className="nav-link-title">Feature Management</span>
              </Link>
            </div>
          </div>
        </div>
      </aside>

      <header className="navbar navbar-expand-md d-print-none">
        <div className="container-xl">
          <button 
            className="navbar-toggler" 
            type="button"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          
          <h1 className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
            <Link to="/lender/brokers" style={{ textDecoration: 'none' }}>
              <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
                <span style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>PRO Portal</span>
                <span style={{ fontSize: '0.7rem', opacity: 0.7 }}>(powered by UFF)</span>
              </div>
            </Link>
          </h1>
          
          <div className="navbar-nav flex-row order-md-last">
            <div className="nav-item dropdown">
              <a href="#" className="nav-link d-flex lh-1 text-reset p-0" data-bs-toggle="dropdown">
                <span className="avatar avatar-sm" style={{ backgroundImage: `url(${currentUser?.avatar})` }}></span>
                <div className="d-none d-xl-block ps-2">
                  <div>{currentUser?.name}</div>
                  <div className="mt-1 small text-secondary">Lender Admin</div>
                </div>
              </a>
              <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                <button onClick={handleLogout} className="dropdown-item">
                  <i className="ti ti-logout me-2"></i>
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
      
      <div className="page-wrapper">
        <div className="page-body">
          <div className="container-xl">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LenderLayout;
